import host from './mapHostContent'
import realties from './mapRealtiesContent'
import observations from './mapObservationsContent'
import client from './mapClientContent'
import creator from './mapCreatorContent'
import visitor from './mapVisitorContent'
import meetAddress from './mapMeetAddressContent'
import displacementAndAuthorization from './mapDisplacementAndAuthorizationContent'
import appointmentConfirmation from './mapAppointmentConfirmationContent'
import additionalData from './mapAdditionalContent'

const accordion = (data) => {
  return `
    ${realties(data)}
    ${host(data)}
    ${observations(data)}
    ${client(data)}
    ${creator(data)}
    ${visitor(data)}
    ${displacementAndAuthorization(data)}
    ${appointmentConfirmation(data)}
    ${additionalData(data)}
    ${meetAddress(data)}
  `
}

export default accordion
